import script from "./LightButtonListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LightButtonListPage.vue?vue&type=script&setup=true&lang=js"

import "./LightButtonListPage.vue?vue&type=style&index=0&id=1f7c7c08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7c7c08"]])

export default __exports__